// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__34fpN","clinicsSelect":"TableHeading_clinicsSelect__3IxWD"};